import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';

const dataProviderName = 'campaigns/campaign'
const model = 'campaigns/campaign'
const wizardName = 'Campaign Activity Outcome';
const wizardObject = 'CampaignActivity';
const wizardAction = 'leadOutcome';

const CampaignActivityCreate = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);

    useLoadOne({loadOne, params })

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "available_employments": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    // svuoto la selezione del drawer padre per evitare riassegnazioni
                    params.setSelected && params.setSelected([]);

                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: dataProviderName, data: {
            campaignLeadId: 0,
            outcomeId:0
        }});
    }

    return (
        <>
            <DetailComponent
                values={{
                    ...item?.data
                }}
                modelName={model.split('/')[1]}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                editing={true}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Assign the {{count}} Leads to the selected {{wizardObject}}', { wizardObject: wizardObject,count: params?.selected?.length ?? 0})}
                    />
                }
                {...params}
            />
        </>
    )
}

export default CampaignActivityCreate;